import faker from 'faker';

export default Array(10)
    .fill(0)
    .map((_, index) => {
        return({
            id: index,
            tipoServico: (index == 0) ? '' : faker.hacker.abbreviation() + ' - ' + faker.commerce.department().toUpperCase(),
            quantidadeContratos: faker.random.number({min: 1, max: 50}),
            contrato: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            medido: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            saldo: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            quantidade: faker.random.number({min: 1, max: 50}),
            deltaValor: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            mediaContrato: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            quantAditivo: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
            deltaAdit: faker.random.number({min: 1, max: 5, precision: 0.01}).toFixed(2),
        })
    });